import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

function PortalDropdown({ anchor, open, onClose, className, children }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ top: 0, right: 0 });

  useEffect(() => {
    if (!open || !anchor?.current) return;
    const r = anchor.current.getBoundingClientRect();
    setPos({ top: r.bottom + 6, right: window.innerWidth - r.right });
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (
        (!anchor?.current || !anchor.current.contains(e.target)) &&
        (!ref.current     || !ref.current.contains(e.target))
      ) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      ref={ref}
      className={className}
      style={{ position: 'fixed', top: pos.top, right: pos.right, zIndex: 9999 }}
    >
      {children}
    </div>,
    document.body
  );
}

export default PortalDropdown;
